import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { WorkSchedule } from './work-schedule.interface';
import { WorkScheduleService } from './work-schedule.service';

const service = new WorkScheduleService();

export interface WorkScheduleState {
   workSchedules: Array<WorkSchedule>;
}

const WorkScheduleStore: Module<WorkScheduleState, StoreState> = {
   namespaced: true,
   state: {
      workSchedules: [],
   },
   getters: { workSchedules: (state) => state.workSchedules },
   mutations: {
      SET_WORK_SCHEDULE(state, workSchedules: Array<WorkSchedule>) {
         state.workSchedules = workSchedules;
      },
   },
   actions: {
      async getWorkSchedules(context, query: LocationQuery) {
         const response = await service.getWorkSchedules({ ...query });
         context.commit('SET_WORK_SCHEDULE', response.data);
         return response;
      },
   },
};

export default WorkScheduleStore;
